import React from 'react';
import Checkbox from '../../shared/Checkbox';

function RecommendationType({ onRecommendationTypeChange }) {
  return (
    <div>
      <h3 className="text-lg font-bold text-rd-navy mb-4 flex items-center">
        <span className="text-2xl mr-2">🎯</span>
        Tipo de Recomendação
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <label className="flex items-center p-4 bg-white border-2 border-gray-200 rounded-lg cursor-pointer hover:border-rd-blue hover:bg-blue-50 transition-all duration-200">
          <Checkbox
            type="radio"
            name="recommendationType"
            value="SingleProduct"
            onChange={() => onRecommendationTypeChange('SingleProduct')}
            className="mr-3"
          />
          <div>
            <div className="font-bold text-rd-navy">Produto Único</div>
            <div className="text-sm text-gray-600">Melhor opção para você</div>
          </div>
        </label>
        <label className="flex items-center p-4 bg-white border-2 border-gray-200 rounded-lg cursor-pointer hover:border-rd-cyan hover:bg-cyan-50 transition-all duration-200">
          <Checkbox
            type="radio"
            name="recommendationType"
            value="MultipleProducts"
            onChange={() => onRecommendationTypeChange('MultipleProducts')}
            className="mr-3"
          />
          <div>
            <div className="font-bold text-rd-navy">Múltiplos Produtos</div>
            <div className="text-sm text-gray-600">Todas as opções disponíveis</div>
          </div>
        </label>
      </div>
    </div>
  );
}

export default RecommendationType;
